var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mpr"},[_c('iframe',{staticStyle:{"border":"medium none"},attrs:{"src":'http://localhost:9000/index.html?' + 'studyId=' + _vm.ids + '&' + 'token=' + _vm.token + '&' + 'index=' + _vm.index + '&reloaded=' + 1}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46fbdc5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mpr/viewer.vue
// module id = null
// module chunks = 